module.exports = __webpack_public_path__ + "static/media/D558GriffinStNW_2018-06-05_25.7477c05b.jpg";